import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const LamnaFeedback = lazy(() => import("@/pages/LamnaFeedback"));

export const Route = createFileRoute("/lamna-feedback")({
  ssr: false,
  validateSearch: (search: Record<string, unknown>) => ({
    t: typeof search["t"] === "string" ? search["t"] : "",
    stars:
      typeof search["stars"] === "string"
        ? search["stars"]
        : typeof search["stars"] === "number"
          ? String(search["stars"])
          : "",
  }),
  head: () => ({
    meta: [
      { title: "Lämna feedback | Elmarknad.se" },
      {
        name: "description",
        content: "Berätta vad vi kan göra bättre – din synpunkt går direkt till vår VD.",
      },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Lämna feedback | Elmarknad.se" },
      {
        property: "og:description",
        content: "Berätta vad vi kan göra bättre – din synpunkt går direkt till vår VD.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <LamnaFeedback />,
});
